// FILECONTENT_START src/common/components/DropDownMenu/index.ts
import DropDownMenu from "./DropDownMenu";
export default DropDownMenu;
export type { DropDownMenuProps } from "./DropDownMenu";

// FILECONTENT_END src/common/components/DropDownMenu/index.ts